import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// If the backend replies 403 with detail "2FA_REQUIRED", surface an event so
// the AdminUnlockDialog can appear anywhere in the app.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && detail === "2FA_REQUIRED") {
      window.dispatchEvent(new Event("admin-unlock-required"));
    }
    // Admin sans 2FA activée : on l'envoie vers la page d'activation (hors boucle, /admin/securite n'est pas protégée par require_admin)
    if (err?.response?.status === 403 && detail === "2FA_SETUP_REQUIRED") {
      if (!window.location.pathname.startsWith("/admin/securite")) {
        try {
          sessionStorage.setItem(
            "admin-2fa-setup-msg",
            "Pour accéder à l'administration, activez d'abord la double authentification.",
          );
        } catch (e) { /* ignore */ }
        window.location.assign("/admin/securite");
      }
    }
    return Promise.reject(err);
  },
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
